export default __webpack_public_path__ + "static/media/format_italic.055c55a8.svg";